module.exports = __webpack_public_path__ + "static/media/add.8addc926.svg";